// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-btn[data-v-0a46235b],\n.v-card[data-v-0a46235b] {\n  border-radius: 4px\n}\n.v-card__title[data-v-0a46235b] {\n  text-transform: uppercase\n}\n", ""]);
// Exports
module.exports = exports;
